export const e2eMode = {
  e2e: false,
  apiRecording: false
};
